<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="14" stroke="white" stroke-width="4" />
    <circle cx="16" cy="9" r="2" fill="white" />
    <rect x="14" y="13" width="4" height="12" rx="2" fill="white" />
  </svg>
</template>

<script>
import { colors } from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 32 },
    height: { type: [Number, String], default: 32 },
    color: { type: String, default: colors.textColor },
  },
};
</script>
